/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const userLayout = require('appComp/page/user/user-layout/user-layout');
const userList = require('appComp/page/user/user-list/user-list');
const userDetail = require("appComp/page/user/user-detail/user-detail");
const carVertify = require("appComp/page/user/car-vertify/car-vertify");
const integralEvent = require("appComp/page/user/integral-event/integral-event-list");
const addIntegralEvent = require("appComp/page/user/integral-event/add-edit-integral/add-integral-event");
const editIntegralEvent = require("appComp/page/user/integral-event/add-edit-integral/edit-integral-event");
const integralRecords = require("appComp/page/user/integral-records/integral-records");
const appFeedback = require("appComp/page/user/app-feedback/app-feedback");

module.exports = {
	"component": userLayout,
	"subRoutes": {
		"/user-list": {
			"title": "用户列表",
      "component": userLayout,
      "subRoutes": {
        "/": {
          "component": userList
        },
        "/user-detail": {
        	"component": userDetail,
          "name":"user-detail",
          "title": "用户详情"
        }
			}
		},
    "/car-vertify": {
      "title": "车主认证记录",
      "component": userLayout,
      "name":"car-vertify",
      "subRoutes": {
        "/": {
          "component": carVertify
        }
      }
    },
    "/integral-event": {
      "title": "积分事件管理",
      "component": userLayout,
      "subRoutes": {
        "/": {
          "component": integralEvent
        },
        "/add-integral-event": {
          "component": addIntegralEvent
        },
        "/edit-integral-event": {
          "component": editIntegralEvent
        }
      }
    },
    "/integral-records": {
      "title": "积分获取记录",
      "component": userLayout,
      "subRoutes": {
        "/": {
          "component": integralRecords
        }
      }
    },
    "/app-feedback": {
      "title": "APP用户反馈",
      "component": userLayout,
      "subRoutes": {
        "/": {
          "component": appFeedback
        }
      }
    }
	}
}



// WEBPACK FOOTER //
// ./src/appBackend/router/user.js